import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import PromoBanner from "./components/PromoBanner";
import EventsPopup from "./components/EventsPopup";
import { ChatWidget } from "./components/ChatWidget";
import LandingPage from "./pages/LandingPage";
import BungeePage from "./pages/BungeePage";
import AerialPage from "./pages/AerialPage";
import CoachingPage from "./pages/CoachingPage";
import AboutPage from "./pages/AboutPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import WaiverPage from "./pages/WaiverPage";
import AdminDashboard from "./pages/AdminDashboard";
import BookingPage from "./pages/BookingPage";
import FAQPage from "./pages/FAQPage";
import BookBungeePage from "./pages/BookBungeePage";
import BookAerialPage from "./pages/BookAerialPage";
import BookPopupPage from "./pages/BookPopupPage";
import BookEventPage from "./pages/BookEventPage";
import ConsultPage from "./pages/ConsultPage";
import ShopPage from "./pages/ShopPage";
import GalleryPage from "./pages/GalleryPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import EventsPage from "./pages/EventsPage";
import AirAcademyPage from "./pages/AirAcademyPage";
import NoiseFastPage from "./pages/NoiseFastPage";
import NoiseFastSuccessPage from "./pages/NoiseFastSuccessPage";
import NoiseFastStartPage from "./pages/NoiseFastStartPage";
import GamesPage from "./pages/GamesPage";
import WorkoutsPage from "./pages/WorkoutsPage";
import TwentyFivePage from "./pages/TwentyFivePage";
import YouthPage from "./pages/YouthPage";

// Import styles
import "./styles/header.css";
import "./styles/footer.css";
import "./styles/landing.css";
import "./styles/services.css";
import "./styles/about.css";
import "./styles/auth.css";
import "./styles/popup.css";
import "./styles/waiver.css";
import "./styles/admin.css";
import "./styles/booking.css";
import "./styles/faq.css";
import "./styles/booking-embed.css";
import "./styles/shop.css";
import "./styles/gallery.css";
import "./styles/legal.css";
import "./styles/events.css";
import "./styles/noisefast.css";
import "./styles/games.css";
import "./styles/promo-banner.css";
import "./styles/workouts.css";
import WorkoutBuilderPage from "./pages/WorkoutBuilderPage";
import TwentyFiveSalesPage from "./pages/TwentyFiveSalesPage";
import Welcome25Page from "./pages/Welcome25Page";
import Access25Page from "./pages/Access25Page";
import "./styles/twentyfive.css";
import "./styles/youth.css";

// Layout wrapper to conditionally show header/footer
const AerialBookRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/book-aerial${search}`} replace />;
};

const AppLayout = () => {
  const location = useLocation();
  
  // Pages that should have NO header/footer (landing pages)
  const noLayoutPaths = ['/noise-fast', '/noise-fast/success', '/workouts/25-for-25', '/25-for-25', '/workouts/access'];
  const hideLayout = noLayoutPaths.some(path => location.pathname.startsWith(path));
  
  return (
    <>
      <ScrollToTop />
      {!hideLayout && <Header />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/bungee" element={<BungeePage />} />
        <Route path="/aerial" element={<AerialPage />} />
        <Route path="/consulting" element={<CoachingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/waiver" element={<WaiverPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/book-bungee" element={<BookBungeePage />} />
        <Route path="/book-aerial" element={<BookAerialPage />} />
        <Route path="/aerial/book-aerial" element={<AerialBookRedirect />} />
        <Route path="/book-popup" element={<BookPopupPage />} />
        <Route path="/book-event" element={<BookEventPage />} />
        <Route path="/consult" element={<ConsultPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/afterschool-interest" element={<Navigate to="/youth" replace />} />
        <Route path="/youth" element={<YouthPage />} />
        <Route path="/air-academy" element={<AirAcademyPage />} />
        <Route path="/noise-fast" element={<NoiseFastPage />} />
        <Route path="/noise-fast/start" element={<NoiseFastStartPage />} />
        <Route path="/noise-fast/success" element={<NoiseFastSuccessPage />} />
        <Route path="/games" element={<GamesPage />} />
        <Route path="/workouts" element={<WorkoutsPage />} />
        <Route path="/workouts/builder" element={<WorkoutBuilderPage />} />
        <Route path="/workouts/25-for-25" element={<TwentyFivePage />} />
        <Route path="/workouts/25-for-25/welcome" element={<Welcome25Page />} />
        <Route path="/workouts/access" element={<Access25Page />} />
        <Route path="/25-for-25" element={<TwentyFiveSalesPage />} />
        <Route path="/admin/*" element={<AdminDashboard />} />
      </Routes>
      {!hideLayout && <Footer />}
      {!hideLayout && <PromoBanner />}
      {!hideLayout && <EventsPopup />}
      {!hideLayout && <ChatWidget />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </div>
  );
}

export default App;
